export default __webpack_public_path__ + "static/media/69-video-content-ta-dah.2b8880cb.gif";